<template>
  <div>
    <el-carousel :interval="5000" :arrow="imgList.length >1 ? 'always' : 'never'" height="420px" :autoplay="false" trigger="click">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <div style="height:100%; padding-bottom: 20px;">
          <video v-if="isVideo(item)" style="width: 100%;height: 100%;" :src="item" controls></video>
          <el-image :src="item" fit="contain" style="height: 100%;display: flex; justify-content: center;" v-else></el-image>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
export default {
  props: {
    imgList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    imgList(ov, nv) {
      console.log(ov);
    }
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false
    };
  },
  methods: {
    isVideo(str) {
      let formatText = str.split('.').pop();
      return formatText == 'mp4' || formatText == 'avi';
    }
  }
};
</script>

<style lang="stylus" scoped>
// .el-carousel__item h3 {
//   color: #475669;
//   font-size: 18px;
//   opacity: 0.75;
//   line-height: 300px;
//   margin: 0;
// }

// .el-carousel__item:nth-child(2n) {
//   background-color: #99a9bf;
// }

// .el-carousel__item:nth-child(2n+1) {
//   background-color: #d3dce6;
// }
</style>
